module.exports = __webpack_public_path__ + "img/uk-flag.17b4a417.png";